// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"67e37430","453":"1cf9e4b5","455":"e5571bba","977":"28ec1364"}[chunkId] + ".chunk.js";
};